import { render, staticRenderFns } from "./DashboardImport.vue?vue&type=template&id=675f45e4&"
import script from "./DashboardImport.vue?vue&type=script&lang=js&"
export * from "./DashboardImport.vue?vue&type=script&lang=js&"
import style0 from "./DashboardImport.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports